import React from 'react';
import Offcanvas from 'react-bootstrap/Offcanvas';
import styled from 'styled-components';
import Text from '../../shared/Text';
import Button from '../../shared/Button';
import FeatureTableRow from '../../shared/FeatureTableRow';
import styles from '../../../utility/styles';
import { ProIconGold, FoundersIcon } from '../../../utility/icons';


const StyledOffcanvas = styled(Offcanvas)`
    background-color: ${styles.colors.background};
    width: 50%;
    max-width: 600px;
    .offcanvas-header .btn-close {
        background: transparent url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.27566 4.27566C3.90811 4.64322 3.90811 5.23914 4.27566 5.60669L10.1984 11.5294L4.27566 17.4521C3.90811 17.8197 3.90811 18.4156 4.27566 18.7832C4.64322 19.1507 5.23914 19.1507 5.60669 18.7832L11.5294 12.8604L17.5859 18.9169C17.9535 19.2845 18.5494 19.2845 18.9169 18.9169C19.2845 18.5494 19.2845 17.9535 18.9169 17.5859L12.8604 11.5294L18.7832 5.60669C19.1507 5.23914 19.1507 4.64322 18.7832 4.27566C18.4156 3.90811 17.8197 3.90811 17.4521 4.27566L11.5294 10.1984L5.60669 4.27566C5.23914 3.90811 4.64322 3.90811 4.27566 4.27566Z' fill='white'/%3e%3c/svg%3e") center / 1em auto no-repeat;
    }
    .offcanvas-header {
        background-color: ${styles.colors.background};
        color: ${styles.colors.white};
        border-bottom: 1px solid var(--tz-hairline-strong, rgba(255, 255, 255, 0.10));
        font-family: var(--Font-Family, "Nunito Sans");
        font-size: var(--Para, 16px);
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
    }
    .offcanvas-body {
        padding: 32px 32px calc(80px + 32px) 32px;
        height: calc(100% - 56px);
        position: relative;
    }
    @media only screen and (max-width: 768px) {
        width: 100%;
    }
`;

const Title = styled(Offcanvas.Title)`
    font-family: var(--Font-Family, "Nunito Sans");
    font-size: var(--Para, 16px);
    font-style: normal;
    font-weight: 600;
    line-height: 24px; /* 150% */
`;

const Header = styled(Offcanvas.Header)`
    padding: 16px 24px;
`;

const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const StyledCol = styled.div`
    display: flex;
    flex-direction: column;
`;

const FooterSection = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: ${styles.colors.background};
    border-top: 1px solid var(--tz-hairline-strong, rgba(255, 255, 255, 0.10));
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 32px;
`;

const LinkButton = styled(Button)`
    color: ${styles.colors.lightGray};
    font-size: 14px;
    font-weight: normal;
    text-decoration: underline;
    background-color: transparent;
`;

const FeatureFooter = styled.div`
    position: relative;
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-self: stretch;
    border-radius: 14px;
    background: ${styles.colors.darkBackground};
    border: 1px solid ${({ $featured }) => ($featured ? 'var(--tz-gold-border, rgba(252, 206, 13, 0.45))' : 'var(--tz-hairline-strong, rgba(255, 255, 255, 0.10))')};
`;

const PlanQuipCallout = styled.div`
    margin: 16px 0 0;
    padding: 12px 14px;
    border-radius: 10px;
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background: ${styles.colors.founders};
    color: #1C2028;
    font-family: ${styles.fonts.geist};
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    & b {
        font-weight: 700;
    }
    & svg {
        flex-shrink: 0;
        margin-top: 2px;
    }
    & span {
        text-wrap: balance;
    }
`;

const PlanQuipTagIcon = () => (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.2' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
        <path d='M20.59 13.41L10.99 3.82A2 2 0 0 0 9.58 3.23H4a1 1 0 0 0-1 1v5.58c0 .53.21 1.04.59 1.42l9.59 9.59a2 2 0 0 0 2.82 0l4.59-4.59a2 2 0 0 0 0-2.82z' />
        <circle cx='7.5' cy='7.5' r='1' fill='currentColor' stroke='none' />
    </svg>
);

const PlanSup = styled.sup`
    color: ${styles.colors.founders};
    font-weight: 500;
    font-size: 0.7em;
    margin-left: 1px;
`;

const planSplit = text => {
    const m = (text || '').replace(/^\+\s*/, '').match(/^(.*?)(\*+)$/)
    return m ? { label: m[1].trim(), marker: m[2] } : { label: (text || '').replace(/^\+\s*/, ''), marker: '' }
}

const PlanCheckSvg = () => (
    <svg width='14' height='14' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' style={{ flexShrink: 0, marginTop: '6px' }}>
        <path d='M4 12.5L9.5 18L20 6.5' stroke={styles.colors.founders} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
);

const PlanFeatureItem = ({ text }) => {
    const { label, marker } = planSplit(text)
    return (
        <div className='d-flex align-items-start' style={{ gap: '10px', marginTop: '8px' }}>
            <PlanCheckSvg />
            <Text.Body color={styles.colors.textPrimary}>{label}{!!marker && <PlanSup>{marker}</PlanSup>}</Text.Body>
        </div>
    )
};

const PlanMicro = styled.span`
    font-family: ${styles.fonts.geistMono};
    font-size: 11px;
    line-height: 16px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${({ color }) => color || styles.colors.lightGray};
`;

const PlanPrice = styled.div`
    font-family: ${styles.fonts.geist};
    font-size: 32px;
    line-height: 38px;
    font-weight: 600;
    letter-spacing: -0.02em;
    font-variant-numeric: tabular-nums;
    color: ${({ $gold }) => ($gold ? styles.colors.founders : styles.colors.textPrimary)};
    margin-top: 8px;
    & small {
        font-size: 15px;
        font-weight: 500;
        letter-spacing: 0;
        color: ${styles.colors.lightGray};
        margin-left: 4px;
    }
`;

const FeatureFooterInverted = styled.div`
    display: flex;
    padding: 16px 24px;
    flex-direction: column;
    align-self: stretch;
    border-radius: 8px;
    border-color: ${styles.colors.founders};
    border-width: 1px;
    border-style: solid;
    background-color: transparent;
`;


const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: center;
    width: 100%;
    padding: 0 16px;

    @media (min-width: 769px) {
        flex-wrap: nowrap;  // Prevent wrapping on desktop
        gap: 16px;
    }

    @media (max-width: 768px) {
        gap: 8px;
    }
`;

const StyledButton = styled(Button)`
    background-color: ${({ color }) => color};
    color: ${({ textColor }) => textColor};
    border: 1px solid ${({ isOutline, textColor, color }) => isOutline ? textColor : color};
    min-width: 120px;
    position: relative;
    
    @media (min-width: 769px) {
        flex: ${({ isFounders }) => isFounders ? '0 0 35%' : '0 0 30%'}; // Founders slightly wider
    }

    @media (max-width: 768px) {
        flex: ${({ isFounders }) => isFounders ? '1 0 100%' : '1 1 45%'};
        max-width: ${({ isFounders }) => isFounders ? '100%' : '45%'};
    }
`;

const OfferBadge = styled.div`
    position: absolute;
    top: -12px;
    right: -12px;
    width: 32px;
    height: 32px;
    background-color: ${styles.colors.founders};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    
    svg {
        width: 28px;
        height: 28px;
        fill: ${styles.colors.black};
    }
`;

const OfferNotice = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 16px;
    color: ${styles.colors.founders};
    
    svg {
        width: 24px;
        height: 24px;
        fill: ${styles.colors.founders};
        flex-shrink: 0;
    }
`;

const returnStyling = index => {

    if (index % 2 === 0) {
        return {
            color: styles.colors.black,
            textColor: styles.colors.founders,
            isOutline: true
        }
    }
    return {
        color: styles.colors.founders,
        textColor: styles.colors.black,
        isOutline: false
    }
}

/**
 * 
 * @param {{
 *   show: boolean,
 *   onHide: () => void,
 *   onPress: (type: 'monthly' | 'annual') => void,
 *   subscription_options: {
 *     title: string,
 *     action: string,
 *   }[],
 *   pricing: {
 *     monthly: string,
 *     annual: string,
 *   },
 *   features: { text:string, freeText:string }[],
 *   keyFeatures: { text:string }[],
 *   disclaimer: string,
 *   foundersDisclaimer: string
 * }} props
 * @returns 
 */
export default function ProUpgradeMenu({ show, onHide, onPress, pricing, subscription_options, features = [], keyFeatures = [], disclaimer, foundersDisclaimer }) {
    const hasOfferBadge = subscription_options?.some(option => option?.show_checkout_offer_badge);
    
    return (
        <StyledOffcanvas show={show} onHide={onHide} placement="end" scroll={true}>
            <Header closeButton>
                <Title>Upgrade to TezLab Pro</Title>
            </Header>
            <Offcanvas.Body style={{ paddingBottom: hasOfferBadge ? 'calc(80px + 32px + 60px)' : 'calc(80px + 32px)' }}>
                <StyledRow style={{ justifyContent: 'center' }}>
                    <ProIconGold />
                </StyledRow>
                <Text.Heading color={styles.colors.founders} type='h3' style={{ textAlign: 'center', marginTop: '16px' }}>Pioneer The EV Lifestyle Like a Pro</Text.Heading>
                <Text.Body style={{ textAlign: 'center', margin: '16px' }}>Become a TezLab Pro member to unlock the full suite of features. Become a TezLab Pro member to unlock the full suite of features. Pro includes 1 vehicle connection and allows additional vehicles by add-on.</Text.Body>
                <FeatureTableRow.Heading />
                {features.map((feature, index) => (
                    <FeatureTableRow.Body
                        size='Body'
                        key={index}
                        freeText={feature.freeText}
                        text={feature.text}
                    />
                ))}
                <FeatureFooter>
                    <div className='d-flex align-items-center justify-content-between'>
                        <PlanMicro color={styles.colors.founders}>TezLab Pro</PlanMicro>
                        <ProIconGold />
                    </div>
                    <PlanPrice $gold>{pricing.annual}<small>/ year</small></PlanPrice>
                    <Text.Caption color={styles.colors.lightGray} style={{ marginTop: '2px' }}>{`or ${pricing.monthly}/month`}</Text.Caption>
                    <PlanQuipCallout><PlanQuipTagIcon /><span>That's <b>20% less</b> than our competition, and <b>100% better</b>.</span></PlanQuipCallout>
                    <PlanMicro style={{ marginTop: '20px' }}>Everything in Basic, plus</PlanMicro>
                    {keyFeatures.map(({ text }) => (
                        <PlanFeatureItem key={text} text={text} />
                    ))}
                    {!!disclaimer && <Text.Tiny color={styles.colors.mediumGray} style={{ whiteSpace: 'pre-line', marginTop: '20px', paddingTop: '14px', borderTop: '1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08))' }}>{disclaimer}</Text.Tiny>}
                </FeatureFooter>
                { subscription_options.filter(option => option.type == "founders_series").map((option)=>(
                    <FeatureFooter $featured style={{ marginTop: '20px' }}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <PlanMicro color={styles.colors.founders}>Founders Series</PlanMicro>
                            <FoundersIcon />
                        </div>
                        {(() => {
                            const price = (option.subtitle || '').match(/US?\$[\d.,]+/)
                            return price ? (
                                <React.Fragment>
                                    <PlanPrice>{price[0]}<small>base contribution</small></PlanPrice>
                                    <Text.Caption color={styles.colors.lightGray} style={{ marginTop: '2px' }}>One contribution of your choice. Yours for life.</Text.Caption>
                                </React.Fragment>
                            ) : (
                                <Text.Body color={styles.colors.founders} variant='bold' style={{ marginTop: '8px' }}>{option.subtitle}</Text.Body>
                            )
                        })()}
                        <PlanMicro style={{ marginTop: '20px' }}>What Founders Series members get</PlanMicro>
                        <PlanFeatureItem text='TezLab Pro for Life' />
                        <PlanFeatureItem text='Tree Planted In Your Name' />
                        <PlanFeatureItem text='In-App Founders Series Badge' />
                        <PlanFeatureItem text='2 Vehicle Connections Included*' />
                        {!!disclaimer && <Text.Tiny color={styles.colors.mediumGray} style={{ whiteSpace: 'pre-line', marginTop: '20px', paddingTop: '14px', borderTop: '1px solid var(--tz-hairline, rgba(255, 255, 255, 0.08))' }}>{foundersDisclaimer}</Text.Tiny>}
                    </FeatureFooter>
                ))}
            </Offcanvas.Body>
            <FooterSection>
                <ButtonContainer>
                    {subscription_options?.map((option, index) => (
                        <StyledButton 
                            key={`option-${index + 1}`}
                            onClick={() => onPress(option.action)} 
                            {...returnStyling(index)}
                            isFounders={option.type === "founders_series"}
                        >
                            {option.button_text}
                            {option?.show_checkout_offer_badge && (
                                <OfferBadge>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320 64C356.8 64 388.8 84.7 404.9 115.1C437.8 105 475 113 501 139C527 165 535 202.3 524.9 235.1C555.3 251.2 576 283.2 576 320C576 356.8 555.3 388.8 524.9 404.9C535 437.8 527 475 501 501C475 527 437.7 535 404.9 524.9C388.8 555.3 356.8 576 320 576C283.2 576 251.2 555.3 235.1 524.9C202.2 535 165 527 139 501C113 475 105 437.7 115.1 404.9C84.7 388.8 64 356.8 64 320C64 283.2 84.7 251.2 115.1 235.1C105 202.2 113 165 139 139C165 113 202.3 105 235.1 115.1C251.2 84.7 283.2 64 320 64zM256 288C273.7 288 288 273.7 288 256C288 238.3 273.7 224 256 224C238.3 224 224 238.3 224 256C224 273.7 238.3 288 256 288zM416 384C416 366.3 401.7 352 384 352C366.3 352 352 366.3 352 384C352 401.7 366.3 416 384 416C401.7 416 416 401.7 416 384zM401 273C410.4 263.6 410.4 248.4 401 239.1C391.6 229.8 376.4 229.7 367.1 239.1L239 367C229.6 376.4 229.6 391.6 239 400.9C248.4 410.2 263.6 410.3 272.9 400.9L401 273z"/></svg>
                                </OfferBadge>
                            )}
                        </StyledButton>
                    ))}
                </ButtonContainer>
                {hasOfferBadge && (
                    <OfferNotice>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M320 64C356.8 64 388.8 84.7 404.9 115.1C437.8 105 475 113 501 139C527 165 535 202.3 524.9 235.1C555.3 251.2 576 283.2 576 320C576 356.8 555.3 388.8 524.9 404.9C535 437.8 527 475 501 501C475 527 437.7 535 404.9 524.9C388.8 555.3 356.8 576 320 576C283.2 576 251.2 555.3 235.1 524.9C202.2 535 165 527 139 501C113 475 105 437.7 115.1 404.9C84.7 388.8 64 356.8 64 320C64 283.2 84.7 251.2 115.1 235.1C105 202.2 113 165 139 139C165 113 202.3 105 235.1 115.1C251.2 84.7 283.2 64 320 64zM256 288C273.7 288 288 273.7 288 256C288 238.3 273.7 224 256 224C238.3 224 224 238.3 224 256C224 273.7 238.3 288 256 288zM416 384C416 366.3 401.7 352 384 352C366.3 352 352 366.3 352 384C352 401.7 366.3 416 384 416C401.7 416 416 401.7 416 384zM401 273C410.4 263.6 410.4 248.4 401 239.1C391.6 229.8 376.4 229.7 367.1 239.1L239 367C229.6 376.4 229.6 391.6 239 400.9C248.4 410.2 263.6 410.3 272.9 400.9L401 273z"/></svg>
                        <Text.Caption color={styles.colors.founders} variant='bold'>Special Offer Savings Applied at Checkout</Text.Caption>
                    </OfferNotice>
                )}
            </FooterSection>
        </StyledOffcanvas>
    );
}